import { StartTime } from '@/types/time'

export type { StartTime }

export interface Ticket {
  uid: string
  plan_name: string
  seat_name: string
  general_admission?: boolean
  barcode: string
  apple_saved?: boolean
  google_saved?: boolean
  additional_info?: string | null
}

export interface StateFeature {
  available: boolean
  msg: string
  verbose?: string
  code?: number
}

// Derived server-side, so an abandoned payment releases it on its own.
export interface ExchangeState {
  active: boolean
  kind: 'upgrade' | 'swap' | null
}

export interface State {
  upgrade?: StateFeature
  refund?: StateFeature
  swap?: StateFeature
  send?: StateFeature
  save?: StateFeature
  shop?: StateFeature
  exchange?: ExchangeState
}

export interface Config {
  seat_map: string
  is_qr: boolean
  verbose_enabled: boolean
  currency?: string
}

export interface WalletMore {
  instances: number
  tickets: number
  from_time: string
}

// Mirrors OrderModel.OrderStatus in up-api.
export enum OrderStatus {
  STANDARD = 'standard',
  MODIFIED = 'modified',
  UPGRADED = 'upgraded',
  UPGRADING = 'upgrading',
  REFUNDED = 'refunded',
  SWAPPED = 'swapped',
  SWAPPING = 'swapping',
  SENT = 'sent',
}

export interface Order {
  uid: string
  // An order can span instances, so uid alone is not unique in the wallet.
  // Stamped from the owning booking; pair with uid for any lookup or cache key.
  instance_uid?: string
  order_id: string
  status: OrderStatus
  tickets: Ticket[]
  // NOTE: per-order eligibility (State) and Config are NOT stored here. They are
  // fetched on demand from order/<uid>/state via useOrderStateQuery(order).
}

export interface Booking {
  instance_uid?: string
  start_time: Date
  start?: StartTime
  event_name: string
  // Free text from the provider; null when the client has no mapping for it.
  event_type?: string | null
  venue_name: string
  thumbnail_url: string
  trailer_url: string | null
  channel_trailer_url?: string | null
  channel_uid: string
  is_qr?: boolean
  orders: Order[]
}

export interface Wallet {
  bookings: Booking[]
  more?: WalletMore
}
